// extracted by mini-css-extract-plugin
module.exports = {"cls1":"header-NavLink-module--cls1--1w5SQ","cls2":"header-NavLink-module--cls2--1dkpY header-NavLink-module--cls1--1w5SQ"};